module.exports = __webpack_public_path__ + "img/close.50368c39.png";